import { FC, useState } from 'react';
import { message, Switch, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { PROFILE_STATUS } from 'constants/users';
import { PERMISSION_ACTIONS, PERMISSION_ROUTES } from 'constants/permissions';
import { updateDoctorStatus } from 'services/api/users';

import { useDoctorProfile } from 'pages/DoctorProfile/DoctorProfileContext';
import { showErrorMessage } from 'utils/showErrorMessage';
import { Private } from 'components/shared';
import useDoctorProfileCache from 'hooks/useDoctorProfileCache';

interface IProps {
  id: string;
  lang: string;
}

const ChangeDoctorStatus: FC<IProps> = ({ id, lang }) => {
  const { t } = useTranslation();
  const { profile, validateProfile } = useDoctorProfileCache({ id, lang });
  const { refresh } = useDoctorProfile();

  const [isUpdating, setIsUpdating] = useState(false);

  const onChange = (value: boolean) => {
    validateProfile(async () => {
      try {
        setIsUpdating(true);
        await updateDoctorStatus(id, {
          status: value ? PROFILE_STATUS.active : PROFILE_STATUS.disabled
        });
        refresh();
        message.success(t('messages.successfully_updated'));
      } catch (err) {
        showErrorMessage(err);
      } finally {
        setIsUpdating(false);
      }
    });
  };

  return (
    <Private
      route={PERMISSION_ROUTES.doctors}
      action={PERMISSION_ACTIONS.disableDoctor}
    >
      <Space align="center">
        Activate Doctor
        <Switch
          value={profile?.status === PROFILE_STATUS.active}
          loading={isUpdating}
          onChange={onChange}
        />
      </Space>
    </Private>
  );
};

export default ChangeDoctorStatus;
